<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">PRIMKE</h2>

  <div class="content-block dnevniPlanWrapper">
    <div class="selectDates">
      <div class="odabirDatuma">
        <label>Datum od:</label>
        <dx-date-box
          #datumOdRef
          [(value)]="datumOd"
          [(max)]="datumDo"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          [acceptCustomValue]="true"
          [openOnFieldClick]="true"
          [showClearButton]="true"
          (onValueChanged)="onValueChangedDatumOd($event)"
          (onInput)="onInputDatumOd($event)"
          (onFocusOut)="onFocusOutDatumOd($event)"
          (onKeyDown)="onKeyDownDatumOd($event)">
        </dx-date-box>
      </div>
      <div class="odabirDatuma">
        <label>Datum do:</label>
        <dx-date-box
          #datumDoRef
          [(value)]="datumDo"
          [(min)]="datumOd"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          [acceptCustomValue]="true"
          [openOnFieldClick]="true"
          [showClearButton]="true"
          (onValueChanged)="onValueChangedDatumDo($event)"
          (onInput)="onInputDatumDo($event)"
          (onFocusOut)="onFocusOutDatumDo($event)"
          (onKeyDown)="onKeyDownDatumDo($event)">
        </dx-date-box>
      </div>
      <div class="odabirDatuma">
        <dx-button
          id="pretrazi"
          #pretraziRef
          class="btn_trazi"
          [disabled]="disableGumb"
          stylingMode="contained"
          text="Prikaži"
          type="success"
          [width]="120"
          (onClick)="pretrazi()">
        </dx-button>
      </div>
    </div>
    <div class="customTable dnevniPlan">

      <dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadingVisible" [showIndicator]="true"
        [showPane]="true" [shading]="true" [closeOnOutsideClick]="false">
      </dx-load-panel>

      <dx-data-grid 
        id="tablicaPrimke" 
        [dataSource]="primke" 
        [showColumnLines]="true"
        [wordWrapEnabled]="true" 
        noDataText="{{ poruka }}"
        keyExpr="pz_id"
        [showBorders]="false" 
        [columnAutoWidth]="true" 
        [columnMinWidth]="60"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onCellPrepared)="onCellPrepared($event)"
        (onSelectionChanged)="onSelectionChanged($event)"
        (onRowClick)="onRowClick($event)">

        <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
          <div class="naslov">
            <h2 class="mb-0">Pregled primki</h2>
            <p class="mt-0">Kliknite na primku za više detalja</p>
          </div>
          <div class="d-inline ml-15">
            <dx-button [disabled]="dozvoliClick == false || pravaZaTrenutniPogled != 2"
              icon="plus"
              hint="Dodaj primku"
              stylingMode="outlined"
              type="success"
              (click)="dodajPrimkuPopup()">
            </dx-button>
            <dx-popup
              [width]="600"
              [height]="'auto'"
              [showTitle]="true"
              title="{{ naslov }}"
              [dragEnabled]="true"
              [closeOnOutsideClick]="false"
              [position]="{ my: 'top', at: 'top', offset: '0 104' }"
              [(visible)]="dodaj_urediPrimkuPopupVisible"
              (onHiding)="popupHidden()">
              <div>
                <div class="dx-field">
                  <div class="dx-field-value w-100">
                    <dx-date-box
                      [(value)]="datum"
                      pickerType="calendar"
                      displayFormat='dd.MM.yyyy.'
                      [disabled]="prikazi_gumb_uredi">
                    </dx-date-box>
                  </div>
                </div>
                <div class="dx-field">
                  <div class="dx-field-value w-100">
                    <dx-select-box
                      [dataSource]="skladista"
                      displayExpr="sifrainaziv"
                      valueExpr="idposlovnica"
                      [(value)]="odabranoSkladiste"
                      placeholder="Odaberite skladište"
                      [searchEnabled]="true"
                      [searchExpr]="['po_sifra', 'po_naziv']"
                      (onValueChanged)="odaberiSkladiste($event)"
                      [disabled]="prikazi_gumb_uredi">
                    </dx-select-box>
                  </div>
                </div>
                <div class="dx-field">
                  <div class="dx-field-value w-100">
                    <dx-select-box
                      [dataSource]="sviPartneri"
                      displayExpr="sifrainaziv"
                      valueExpr="pa_id"
                      [(value)]="odabraniPartner"
                      placeholder="Odaberite partnera"
                      [showClearButton]="true"
                      [searchEnabled]="true"
                      [searchExpr]="['pa_sifra', 'pa_naziv']"
                      (onValueChanged)="odaberiPartnera($event)">
                    </dx-select-box>
                  </div>
                </div>
                <div class="dx-field">
                  <div class="dx-field-value w-100">
                    <dx-select-box
                      [dataSource]="poslovnicePartneraFilter"
                      displayExpr="pp_naziv"
                      valueExpr="pp_id"
                      [(value)]="odabranaPoslovnicaPartnera"
                      placeholder="Odaberite poslovnicu partnera"
                      [showClearButton]="true"
                      [searchEnabled]="true"
                      [searchExpr]="['pp_sifra', 'pp_naziv']"
                      (onValueChanged)="odaberiPoslovnicuPartnera($event)">
                    </dx-select-box>
                  </div>
                </div>
                <div class="dx-field">
                  <div class="dx-field-value w-100">
                    <dx-text-box 
                      placeholder="Broj otpremnice" 
                      [(value)]="brojOtpremnice"
                      [disabled]="prikazi_gumb_uredi">
                    </dx-text-box>
                  </div>
                </div>
                <div class="dx-field">
                  <div class="dx-field-value w-100">
                    <dx-text-area 
                      placeholder="Napomena" 
                      [(value)]="napomena">
                    </dx-text-area>
                  </div>
                </div>
                <div class="dx-field float-right">
                  <dx-button *ngIf="prikazi_gumb_dodaj"
                    [disabled]="odabranoSkladiste == null"
                    stylingMode="contained"
                    text="Dodaj"
                    type="success"
                    [width]="120"
                    (onClick)="dodajPrimku()">
                  </dx-button>
                  <dx-button *ngIf="prikazi_gumb_uredi"
                    [disabled]="odabranoSkladiste == null"
                    stylingMode="contained"
                    text="Uredi"
                    type="success"
                    [width]="120"
                    (onClick)="urediPrimku()">
                  </dx-button>
                </div>
              </div>
            </dx-popup>
          </div>
        </div>

        <dxo-header-filter 
          [visible]="true">
        </dxo-header-filter>

        <dxo-scrolling 
          columnRenderingMode="virtual" 
          [showScrollbar]="'always'">
        </dxo-scrolling>

        <dxo-search-panel 
          [visible]="true" 
          [width]="210" 
          placeholder="Pretraži...">
        </dxo-search-panel>

        <dxo-paging 
          [enabled]="true" 
          [pageSize]="10">
        </dxo-paging>

        <dxo-pager 
          [showPageSizeSelector]="true" 
          [allowedPageSizes]="[10, 20, 30]" 
          [showInfo]="true">
        </dxo-pager>

        <dxo-selection 
          mode="single">
        </dxo-selection>

        <dxi-column 
          dataField="pz_broj" 
          caption="Broj primke" 
          [width]="150" 
          alignment="right"
          [calculateSortValue]="calculateSortValue">
        </dxi-column>
        <dxi-column caption="Povezani dokumenti" cellTemplate="cellLink" [width]="100" alignment="center">
          <div *dxTemplate="let data of 'cellLink'">
            <dx-button hint="Povezani dokumenti" icon="link" (onClick)="povezaniDokumenti(data)"></dx-button>
          </div>
        </dxi-column>
        <dxi-column 
          dataField="pz_datum" 
          dataType="date" 
          caption="Datum" 
          [width]="130"
          alignment="center">
        </dxi-column>
        <dxi-column 
          dataField="uf_broj" 
          caption="UFA/IFA"
          [width]="120">
        </dxi-column>
        <dxi-column 
          dataField="po_sifra" 
          caption="Šifra skladišta"
          [width]="160">
        </dxi-column>
        <dxi-column 
          dataField="po_naziv" 
          caption="Naziv skladišta">
        </dxi-column>
        <dxi-column 
          dataField="pa_sifra" 
          caption="Šifra partnera"
          [width]="160">
        </dxi-column>
        <dxi-column 
          dataField="pa_naziv" 
          caption="Naziv partnera">
        </dxi-column>
        <dxi-column 
          dataField="pp_naziv" 
          caption="Poslovnica partnera">
        </dxi-column>
        <dxi-column 
          dataField="pz_napomena" 
          caption="Napomena">
        </dxi-column>
        <dxi-column 
          dataField="pz_iznos" 
          caption="Iznos"
          [width]="160"
          alignment="right"><dxo-format type="fixedPoint" [precision]="2"></dxo-format>
        </dxi-column>
        <dxi-column 
          dataField="pz_porez" 
          caption="Porez"
          [width]="160"
          alignment="right"><dxo-format type="fixedPoint" [precision]="2"></dxo-format>
        </dxi-column>
        <dxi-column
          dataField="pz_status"
          caption="Status"
          [width]="120"
          alignment="center">
        </dxi-column>
        <dxi-column 
          dataField="name" 
          caption="Kreirao">
        </dxi-column>
        <dxi-column caption="PDF" cellTemplate="pdf" [width]="70" alignment="center" [fixed]="true" fixedPosition="right">
          <div *dxTemplate="let data of 'pdf'">
            <dx-button hint="PDF" icon="pdffile" (onClick)="primkaPDF(data)"></dx-button>
          </div>
        </dxi-column>
        <dxi-column type="buttons" alignment="center" [fixed]="true" fixedPosition="right"><dxi-button template="uredjivanje"></dxi-button></dxi-column>
          <div *dxTemplate="let data of 'uredjivanje'">
            <dx-button *ngIf="data.data.pz_status == 'Z'" [disabled]="data.data.pz_status != 'Z' || pravaZaTrenutniPogled != 2" hint="Storniraj" icon="close" (onClick)="stornirajPrimku(data)"></dx-button>
            <dx-button *ngIf="data.data.pz_status == 'I'" [disabled]="data.data.pz_status != 'I' || pravaZaTrenutniPogled != 2" hint="Završi" icon="check" (onClick)="zavrsiPrimku(data)"></dx-button>
            <dx-button *ngIf="data.data.pz_status == 'I' || data.data.pz_status == 'Z'" [disabled]="dozvoliClick == false || pravaZaTrenutniPogled != 2" icon="edit" hint="Uredi" (onClick)="urediPrimkuPopup(data)"></dx-button>
            <dx-button *ngIf="data.data.pz_status == 'I'" [disabled]="pravaZaTrenutniPogled != 2" hint="Obriši" icon="trash" (onClick)="obrisiPrimku(data)"></dx-button>
          </div>
        
        <dxo-summary *ngIf="primke.length > 0">
          <dxi-total-item column="pp_naziv" alignment="left" displayFormat="UKUPNO: "></dxi-total-item>
          <dxi-total-item column="pz_iznos" summaryType='sum' alignment="right" displayFormat="{0}" [valueFormat]="{ type: 'fixedPoint', precision: 2 }"></dxi-total-item>
          <dxi-total-item column="pz_porez" summaryType='sum' alignment="right" displayFormat="{0}" [valueFormat]="{ type: 'fixedPoint', precision: 2 }"></dxi-total-item>
        </dxo-summary>

        <dxo-master-detail 
          [enabled]="false" 
          template="detail">
        </dxo-master-detail>

        <div *dxTemplate="let data of 'detail'">
          <!-- <p *ngIf="stavke.length === 0">Dohvaćanje podataka...</p>
          <div *ngIf="stavke.length > 0"> -->
          <div *ngIf="isLoading" class="content-block">Dohvaćanje podataka...</div>
          <div *ngIf="!isLoading">
            <div class="stavke">
              <!--problem što se pri dnu tablice klikom na red ne prikaže cijela tree lista (mora se dva puta kliknuti onda bude dobro) -->
              <!-- dx-tree-list  -->
              <dx-data-grid 
                [dataSource]="stavke" 
                [wordWrapEnabled]="true" 
                keyExpr="ps_id"
                [showBorders]="true" 
                (onInitNewRow)="onInitNewRow($event)"
                (onEditingStart)="onEditingStart($event)" 
                (onRowUpdated)="onRowUpdated($event)"
                (onToolbarPreparing)="onToolbarPreparingStavke($event)">

                <dxo-editing 
                  mode="popup" 
                  [allowUpdating]="false"
                  [allowAdding]="false"
                  [allowDeleting]="false">

                  <dxo-popup 
                    [onShowing]="onShowing" 
                    title="" 
                    [showTitle]="true" 
                    [width]="500" 
                    [height]="'auto'">
                  </dxo-popup>

                  <dxo-form>
                    <dxi-item itemType="group" [colCount]="1" [colSpan]="2">
                      <dxi-item dataField="ar_sifra"></dxi-item>
                      <dxi-item dataField="ar_naziv"></dxi-item>
                      <dxi-item dataField="ps_ulaz"></dxi-item>
                      <dxi-item dataField="jedinicamjere_JM_SIFRA"></dxi-item>
                      <dxi-item dataField="zss_ar_lot"></dxi-item>
                    </dxi-item>
                  </dxo-form>

                </dxo-editing>

                <dxi-column 
                  dataField="ar_lot" 
                  caption="LOT" 
                  [width]="120" 
                  [allowEditing]="false">
                </dxi-column>
                <dxi-column 
                  dataField="ar_sifra" 
                  caption="Šifra" 
                  [width]="120" 
                  [allowEditing]="false">
                </dxi-column>
                <dxi-column 
                  dataField="ar_naziv" 
                  caption="Sirovina" 
                  [width]="400" 
                  [allowEditing]="false">
                </dxi-column>
                <dxi-column 
                  dataField="ps_ulaz" 
                  caption="Količina" 
                  [width]="150"><dxo-format type="fixedPoint" [precision]="3"></dxo-format>
                </dxi-column>
                <dxi-column 
                  dataField="jedinicamjere_JM_SIFRA" 
                  caption="Jed.mj." 
                  [width]="80" 
                  [allowEditing]="false"><dxo-format type="fixedPoint" [precision]="2"></dxo-format>
                </dxi-column>
                <dxi-column 
                  dataField="ps_nabcij" 
                  caption="Bruto cijena" 
                  [width]="100"><dxo-format type="fixedPoint" [precision]="5"></dxo-format>
                </dxi-column>
                <dxi-column 
                  dataField="ps_bruto_vrijednost" 
                  caption="Bruto vrijednost" 
                  [width]="120"><dxo-format type="fixedPoint" [precision]="2"></dxo-format>
                </dxi-column>
                <dxi-column 
                  dataField="ps_postorabata" 
                  caption="Rabat (%)" 
                  [width]="80">
                </dxi-column>
                <dxi-column 
                  dataField="ps_rabat" 
                  caption="Rabat iznos" 
                  [width]="100"><dxo-format type="fixedPoint" [precision]="2"></dxo-format>
                </dxi-column>
                <dxi-column 
                  dataField="ps_ulazc" 
                  caption="Neto cijena" 
                  [width]="100"><dxo-format type="fixedPoint" [precision]="5"></dxo-format>
                </dxi-column>
                <dxi-column 
                  dataField="ps_ulazvr" 
                  caption="Neto vrijednost" 
                  [width]="110"><dxo-format type="fixedPoint" [precision]="2"></dxo-format>
                </dxi-column>
                <dxi-column 
                  dataField="ps_vazido" 
                  dataType="date"
                  caption="Rok trajanja" 
                  [width]="120">
                </dxi-column>
                <dxi-column cellTemplate="uredjivanjeStavke" [width]="150" alignment="center">
                  <div *dxTemplate="let data of 'uredjivanjeStavke'">
                    <dx-button [disabled]="data.data.pz_status != 'I'" icon="edit" type="default" class="edit_stavke" (onClick)="stavkaDetalji(data)"></dx-button>
                    <dx-button [disabled]="pravaZaTrenutniPogled != 2" icon="print" hint="Ispis QR kodova"(onClick)="pdfIzdatnicaLotSirovinaPojedinacno(data)"></dx-button>
                    <dx-button [disabled]="data.data.pz_status != 'I'" icon="trash" type="danger" (onClick)="obrisiStavku(data)"></dx-button>
                  </div>
                </dxi-column>
              </dx-data-grid>
            </div>
          </div>
        </div>
      </dx-data-grid>
    </div>
  </div>
</div>


<dx-popup
  [title]="naslov"
  [showTitle]="true"
  [width]="800"
  [height]="'auto'"
  (onHidden)="popupHiddenStavke()"
  [closeOnOutsideClick]="false"
  [showCloseButton]="true"
  [(visible)]="dodajStavkuPopup"
  [position]="{ my: 'center', at: 'center', of: window }">


  <div id="form-container">
    <dx-form class="content-block" id="form" [formData]="podaci_stavka" #formaStavke>
      <!-- (onFieldDataChanged)="editStavka($event)" -->
      <dxi-item itemType="group" [colCount]="2">
        <dxi-item dataField="ar_id" [label]="{value: idArtikl, text: 'Naziv artikla*'}" [colSpan]="2">
          <div *dxTemplate>
            <dx-autocomplete placeholder="" [minSearchLength]="1" valueExpr='sifrainaziv' (onItemClick)="odaberiArtikl($event)"
              [dataSource]="sviArtikli" [(value)]="odabranArtikl" [showClearButton]="true">
            </dx-autocomplete>
          </div>
        </dxi-item>
        <dxi-item dataField="za_nabcij" [label]="{text: 'Trenutna nabavna cijena'}" editorType="dxNumberBox" [editorOptions]="{readOnly: true}"></dxi-item>
        <dxi-item dataField="za_stanje" [label]="{text: 'Zaliha'}" editorType="dxNumberBox" [editorOptions]="{readOnly: true}"></dxi-item>
      </dxi-item>
      <dxi-item itemType="group" [colCount]="2">
        <dxi-item dataField="ps_ulaz" [label]="{text: 'Količina'}" editorType="dxNumberBox"
          [editorOptions]="{value: kolicinaPopup, onValueChanged: onChangeKolicina }"></dxi-item>
        <dxi-item dataField="jedinicamjere_JM_SIFRA" [label]="{text: 'Jedinica mjere'}" [editorOptions]="{readOnly: true}"></dxi-item>
      </dxi-item>
      <dxi-item itemType="group" [colCount]="2">
        <dxi-item dataField="ps_nabcij" [label]="{text: 'Bruto cijena'}" editorType="dxNumberBox" 
          [editorOptions]="{value: cijenaPopup, min: 0, format: { type: 'fixedPoint', precision: 5 }, onValueChanged: cijenaIzmijenjena}"></dxi-item>
        <dxi-item dataField="pz_posto" [label]="{text: 'PDV (%)'}" [editorOptions]="{readOnly: true}"></dxi-item>
      </dxi-item>
      <dxi-item itemType="group" [colCount]="2">
        <dxi-item dataField="ps_bruto_vrijednost" [label]="{text: 'Bruto vrijednost'}" editorType="dxNumberBox"
          [editorOptions]="{value: brutoPopup, min: 0, format: { type: 'fixedPoint', precision: 5 }, onValueChanged: onChangeBV}"></dxi-item>
        <dxi-item dataField="ps_vazido" [label]="{text: 'Vrijedi do'}" editorType="dxDateBox" [editorOptions]="{displayFormat:'dd.MM.yyyy.', showClearButton: 'true'}"></dxi-item>
      </dxi-item>
      <dxi-item itemType="group" [colCount]="2">
        <dxi-item dataField="ps_postorabata" [label]="{text: 'Rabat (%)'}" editorType="dxNumberBox" 
          [editorOptions]="{value: rabatPopup, min: 0, onValueChanged: onValuChangedRabat}"></dxi-item>
      </dxi-item>
      <dxi-item itemType="group" [colCount]="2">
        <dxi-item dataField="ps_rabat" [label]="{text: 'Rabat iznos'}" editorType="dxNumberBox" 
          [editorOptions]="{value: rabat_iznosPopup, readOnly: true}"></dxi-item>
      </dxi-item>
      <dxi-item itemType="group" [colCount]="2">
        <dxi-item dataField="neto_cijena" [label]="{text: 'Neto cijena'}" editorType="dxNumberBox"
          [editorOptions]="{value: netoCijena, min: 0, format: { type: 'fixedPoint', precision: 5 }, onValueChanged: onValuChangedNC}">
        </dxi-item>
      </dxi-item>
      <dxi-item itemType="group" [colCount]="2">
        <dxi-item dataField="neto_vrijednost" [label]="{text: 'Neto vrijednost'}" editorType="dxNumberBox" 
          [editorOptions]="{value: netoVrijednost, onValueChanged: onChangeNV}"></dxi-item>
      </dxi-item>

    </dx-form><br>
    <dxi-item class="btn_group">
      <dx-button *ngIf="btn_uredi_stavka != 1" stylingMode="contained" [height]="40" [width]="120" type="success"
        (onClick)="dodajStavku(podaci_stavka)" class="spremiPonudu">DODAJ</dx-button>
      <dx-button *ngIf="btn_uredi_stavka == 1" stylingMode="contained" [height]="40" [width]="120" type="success"
        (onClick)="urediStavku(podaci_stavka)" class="spremiPonudu">SPREMI</dx-button>
      <dx-button stylingMode="contained" [height]="40" [width]="120" type="danger" (onClick)="odustaniStavka()"
        class="spremiPonudu">ODUSTANI</dx-button><br><br>
    </dxi-item>
  </div>
</dx-popup>


<dx-popup
  [title]="naslov"
  [showTitle]="true"
  [width]="1000"
  [height]="'auto'"
  [closeOnOutsideClick]="false"
  [showCloseButton]="true"
  [(visible)]="povezaniDokumentiPopup"
  [position]="{ my: 'center', at: 'center', of: window }">

  <dx-data-grid
    id="tablicaPovezaniDokumenti"
    [dataSource]="povezani_dokumenti"
    [showColumnLines]="true"
    [wordWrapEnabled]="true"
    [showBorders]="false">
    <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
    <dxi-column
      dataField="pz_broj"
      caption="Broj"
      [width]="100" 
      alignment="right">
    </dxi-column>
    <dxi-column
      dataField="DV_NAZIV"
      caption="Vrsta"
      alignment="center">
    </dxi-column>
    <dxi-column
      dataField="pz_datum"
      dataType="date" 
      caption="Datum"
      [width]="130"
      alignment="center">
    </dxi-column>
     <dxi-column
      dataField="fi_naziv"
      caption="Firma">
    </dxi-column>
    <dxi-column
      dataField="po_naziv"
      caption="Naziv skladišta">
    </dxi-column>
  </dx-data-grid>
  <br>
  <dxi-item class="btn_group">
    <dx-button stylingMode="contained" [height]="40" [width]="120" type="success" (onClick)="uredu()">UREDU</dx-button><br><br>
  </dxi-item>
</dx-popup>